
function flattenSlot(data) {
    data = angular.copy(data);
    data.grant_year = data.slot_type.year;
    data.slot_type = data.slot_type.type;
    return data;
}

module.directive('newAmericorpsSlotForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/americorps/americorpsSlotForm',
        scope: {participantId: "=", programId: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                data = flattenSlot(data);
                return ModelService.postRelation('participant', scope.participantId,
                                                 'slots', data);
            };
        },
    };
});

module.directive('americorpsSlotForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/americorps/americorpsSlotForm',
        scope: {slot: "=", programId: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {
                amc_enrollment_date: moment(scope.slot.amc_enrollment_date),
                slot_type: {
                    year: scope.slot.grant_year,
                    type: scope.slot.slot_type,
                },
            };
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                data = flattenSlot(data);
                return ModelService.patchModel(scope.slot, data);
            };
        },
    };
});


module.directive('edAwardForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/americorps/edAwardForm',
        scope: {slot: "=", programId: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {
                ed_award_date: angular.copy(scope.slot.ed_award_date)};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.slot, data);
            };

            basicForm.setDeleteFunctions(function() {
                ModelService.patchModel(scope.slot, {
                    ed_award_date: null,
                });
            }, function() {
                return scope.slot.ed_award_date;
            });
        },
    };
});
